import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {
  MatButtonModule,
  MatCheckboxModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatTableModule,
  MatCardModule,
  MatTooltipModule,
  MatExpansionModule,
  MatDividerModule} from '@angular/material';
import { UsageRoutingModule } from './usage-routing.module';
import { UsageDetailsComponent } from './usage-details.component';
import { UsagePaymentsService } from 'app/payment/usage-payments/usage-payments.service';
@NgModule({
schemas: [
    CUSTOM_ELEMENTS_SCHEMA
],
  imports: [
    CommonModule,
    UsageRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatTooltipModule,
    MatExpansionModule,
    MatDividerModule,
    MatCardModule
  ],
  providers: [UsagePaymentsService, TitleCasePipe],
  declarations: [UsageDetailsComponent]
})
export class UsageModule { }



// WEBPACK FOOTER //
// ./src/app/usage/usage.module.ts